import {GatewayEditor} from "./GatewayEditor";

export class AndGatewayEditor extends GatewayEditor {

	constructor(parent, node, coords) {
		super(parent, node, coords);
	}

	drawTypeSymbol(ctx, rect) {
		ctx.save();
		ctx.lineWidth = 3 * this.lineWidth;

		ctx.strokeStyle=this.typeColor;
		ctx.beginPath();
		ctx.moveTo(rect.left + rect.width / 2, rect.top + rect.height / 4);
		ctx.lineTo(rect.left + rect.width / 2, rect.top + 3/4*rect.height);
		ctx.moveTo(rect.left + 1/4*rect.width, rect.top + rect.height / 2);
		ctx.lineTo(rect.left + 3/4*rect.width, rect.top + rect.height / 2);
		ctx.stroke();

		ctx.restore();
	}
}